/*
vuex最核心的管理对象store
 */
import { createStore } from 'vuex'
/*
相当于data对象的状态对象
 */
const state = {
  sharedData: null,
  selectMenu: null,
  tabList: [],
  count: 0,  // 指定初始化数据
  userInfo: null, //全局变量用户ID
  role:null,
  token:null
}

/*
包含了n个直接更新状态的方法的对象
 */
const mutations = {
  setSharedData(state, data) {
    state.sharedData = data;
  },
  INCREMENT (state) {
    state.count++
  },
  DECREMENT (state) {
    state.count--
  },
  selectMenu (state, val) {
    state.selectedMenu = val
    const result = state.tabList.findIndex(item => item.path === val.path)
    result === -1 ? state.tabList.push(val) : ''
  },
  closeTab (state, val) {
    const result = state.tabList.findIndex(item => item.path === val.path)
    state.tabList.splice(result, 1)
  },
  setUserInfo(state, user) {
    state.userInfo = user
  },
  setRole(state, type) {
    state.role = type
  },
  setToken(state, token) {
    state.token = token
  },
  // 新增：清空所有状态（用于退出登录）
  clearAllState(state) {
    state.userInfo = null
    state.role = null
    state.token = null
    state.selectedMenu = null
    state.tabList = []
    state.sharedData = null
  }
}

/*
包含了n个间接更新状态的方法的对象  actions-->mutations
 */
const actions = {
  increment ({commit}) {
    // 提交一个mutation请求
    commit('INCREMENT')
  },
  decrement ({commit}) {
    // 提交一个mutation请求
    commit('DECREMENT')
  },
  incrementIfOdd ({commit, state}) {
    if(state.count%2===1) {
      // 提交一个mutation请求
      commit('INCREMENT')
    }
  },
  incrementAsync ({commit}) {
    setTimeout(() => {
      // 提交一个mutation请求
      commit('INCREMENT')
    }, 1000)
  },
  setUserInfo({ commit }, user) {
    commit('setUserInfo', user)
    // 修复：存储对象时需要序列化
    localStorage.setItem('userInfo', JSON.stringify(user));
  },
  setRole({ commit }, type) {
    commit('setRole', type)
    localStorage.setItem('role', type);
  },
  setToken({ commit }, token) {
    commit('setToken', token)
    localStorage.setItem('token', token);
  },
  // 新增：退出登录action
  logout({ commit }) {
    commit('clearAllState')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('role')
    localStorage.removeItem('token')
  },
  // 新增：初始化状态（从本地存储恢复）
  initState({ commit }) {
    const userInfo = localStorage.getItem('userInfo')
    const role = localStorage.getItem('role')
    const token = localStorage.getItem('token')

    if (userInfo) {
      try {
        // 修复：解析JSON字符串为对象
        commit('setUserInfo', JSON.parse(userInfo))
      } catch (e) {
        console.error('解析用户信息失败', e)
        localStorage.removeItem('userInfo')
      }
    }
    
    if (role) {
      commit('setRole', role)
    }

    if (token) {
      commit('setToken', token)
    }
  }
}

/*
包含多个getter计算属性的对象
 */
const getters = {
  evenOrOdd (state) { // 当读取属性值时自动调用并返回属性值
    return state.count%2===0 ? '偶数' : '奇数'
  },
  // 新增：获取登录状态
  isLogin(state) {
    return !!state.userInfo
  }
}

/**向外暴露store 对象**/
export default createStore({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    (store) => {
      // 初始化时恢复状态
      store.dispatch('initState')
    }
  ]
})
